/**
=========================================================
* Stat Card Component
=========================================================

* A simple statistics card displaying a title, value, and icon.
* Used for displaying key metrics in dashboards.
*/

import Icon from '@mui/material/Icon'

import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'

interface StatCardProps {
	title: string
	value: string | number
	icon: string
	color?: 'primary' | 'info' | 'success' | 'warning' | 'error' | 'secondary'
}

function StatCard({ title, value, icon, color = 'info' }: StatCardProps): JSX.Element {
	return (
		<MDBox
			p={2}
			borderRadius="lg"
			sx={{
				backgroundColor: 'rgba(0,0,0,0.02)',
				border: '1px solid rgba(0,0,0,0.05)',
			}}
		>
			<MDBox display="flex" alignItems="center" gap={2}>
				<MDBox
					display="flex"
					justifyContent="center"
					alignItems="center"
					width="3rem"
					height="3rem"
					borderRadius="lg"
					bgColor={color}
					color="white"
				>
					<Icon>{icon}</Icon>
				</MDBox>
				<MDBox>
					<MDTypography variant="caption" color="text" fontWeight="medium">
						{title}
					</MDTypography>
					<MDTypography variant="h5">{value}</MDTypography>
				</MDBox>
			</MDBox>
		</MDBox>
	)
}

export default StatCard
